import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React, { lazy, useEffect, useState, Suspense } from 'react';
import { IconButton, Paper, Typography, useTheme, alpha } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import MenuIcon from '@mui/icons-material/Menu';
import { observer } from 'mobx-react';
import { isAlive } from 'mobx-state-tree';
import useMeasure from 'react-use-measure';
import { Menu, Logomark } from '@jbrowse/core/ui';
import { getSession } from '@jbrowse/core/util';
var AboutDialog = lazy(function () {
  return import('./AboutDialog');
});
var useStyles = makeStyles()(function (theme) {
  return {
    viewContainer: {
      overflow: 'hidden',
      background: theme.palette.secondary.main,
      margin: theme.spacing(0.5)
    },
    icon: {
      color: theme.palette.secondary.contrastText
    },
    displayName: {
      marginTop: 2,
      color: theme.palette.secondary.contrastText
    },
    grow: {
      flexGrow: 1
    },
    iconRoot: {
      '&:hover': {
        backgroundColor: alpha(theme.palette.secondary.contrastText, theme.palette.action.hoverOpacity),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    }
  };
});
var ViewMenu = observer(function (_ref) {
  var model = _ref.model,
    IconButtonProps = _ref.IconButtonProps,
    IconProps = _ref.IconProps;
  var _a;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    anchorEl = _useState2[0],
    setAnchorEl = _useState2[1];
  if (!((_a = model.menuItems()) === null || _a === void 0 ? void 0 : _a.length)) {
    return null;
  }
  return React.createElement(React.Fragment, null, React.createElement(IconButton, _objectSpread({}, IconButtonProps, {
    "aria-label": "more",
    "aria-controls": "view-menu",
    "aria-haspopup": "true",
    onClick: function onClick(event) {
      return setAnchorEl(event.currentTarget);
    },
    "data-testid": "view_menu_icon"
  }), React.createElement(MenuIcon, _objectSpread({}, IconProps))), React.createElement(Menu, {
    anchorEl: anchorEl,
    open: Boolean(anchorEl),
    onMenuItemClick: function onMenuItemClick(_, callback) {
      callback();
      setAnchorEl(undefined);
    },
    onClose: function onClose() {
      return setAnchorEl(undefined);
    },
    menuItems: model.menuItems()
  }));
});
var ViewContainer = observer(function (_ref2) {
  var view = _ref2.view,
    children = _ref2.children;
  var _useStyles = useStyles(),
    classes = _useStyles.classes;
  var theme = useTheme();
  var session = getSession(view);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dlgOpen = _useState4[0],
    setDlgOpen = _useState4[1];
  var _useMeasure = useMeasure(),
    _useMeasure2 = _slicedToArray(_useMeasure, 2),
    ref = _useMeasure2[0],
    width = _useMeasure2[1].width;
  var padWidth = theme.spacing(1);
  useEffect(function () {
    if (width && isAlive(view)) {
      view.setWidth(width - parseInt(padWidth, 10) * 2);
    }
  }, [padWidth, view, width]);
  return React.createElement(Paper, {
    elevation: 12,
    ref: ref,
    className: classes.viewContainer,
    style: {
      padding: "0px ".concat(padWidth, " ").concat(padWidth)
    }
  }, session.DialogComponent ? React.createElement(Suspense, {
    fallback: React.createElement("div", null)
  }, React.createElement(session.DialogComponent, _objectSpread({}, session.DialogProps))) : null, React.createElement("div", {
    style: {
      display: 'flex'
    }
  }, React.createElement(ViewMenu, {
    model: view,
    IconButtonProps: {
      classes: {
        root: classes.iconRoot
      },
      edge: 'start'
    },
    IconProps: {
      className: classes.icon
    }
  }), React.createElement("div", {
    className: classes.grow
  }), view.displayName ? React.createElement(Typography, {
    variant: "body2",
    className: classes.displayName
  }, view.displayName) : null, React.createElement("div", {
    className: classes.grow
  }), React.createElement(IconButton, {
    onClick: function onClick() {
      return setDlgOpen(true);
    }
  }, React.createElement("div", {
    style: {
      width: 22,
      height: 22
    }
  }, React.createElement(Logomark, {
    variant: "white"
  })))), React.createElement(Paper, null, children), dlgOpen ? React.createElement(Suspense, {
    fallback: React.createElement("div", null)
  }, React.createElement(AboutDialog, {
    open: true,
    onClose: function onClose() {
      return setDlgOpen(false);
    }
  })) : null);
});
export default ViewContainer;